// src/app/app.config.ts
import { ApplicationConfig } from '@angular/core';
import { importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { CommonModule, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { routes } from './app-routing'; // Import your routes
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import { provideNgIdleKeepalive } from '@ng-idle/keepalive';
import { tokenInterceptor } from './shared/interceptors/token.interceptor';
import { APP_INITIALIZER } from '@angular/core';
import { TokenService } from './shared/services/token.service';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { provideToastr } from 'ngx-toastr';
import { LicenseManager } from 'ag-grid-enterprise';
import { DefaultTreeviewI18n, TreeviewI18n } from 'ngx-treeview-v2';


LicenseManager.setLicenseKey("CompanyName=SHI International Corp_on_behalf_of_Ernst & Young U.S LLP,LicensedApplication=EY Virtual App Store,LicenseType=SingleApplication,LicensedConcurrentDeveloperCount=7,LicensedProductionInstancesCount=7,AssetReference=AG-023644,ExpiryDate=20_December_2022_[v2]_MTY3MTQ5NDQwMDAwMA==2f5795ed99c1f2b169491e5ba7389b22");


export function tokenRefreshFactory(tokenService: TokenService) {
  return () => tokenService.acquireRefreshToken().subscribe();
}
export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes), // Set up routing
    provideNgIdleKeepalive(),
    importProvidersFrom(
      CommonModule,
      BrowserModule,
      BrowserAnimationsModule
    ), // Import BrowserModule for browser-specific features
    importProvidersFrom(), // Ensure BrowserModule is imported for browser-specific features
    {
      provide: APP_INITIALIZER,
      useFactory: tokenRefreshFactory,
      deps: [TokenService],
      multi: true
    },
    provideHttpClient(
      withInterceptors([tokenInterceptor])
    ),
    { provide: LocationStrategy, useClass: PathLocationStrategy },
    provideToastr({
      timeOut: 2000,
      positionClass: 'toast-top-right',
      preventDuplicates: true,
    }),
    { provide: TreeviewI18n, useClass: DefaultTreeviewI18n }
  ],
};
